import { Size } from '@ps/web-core-enums';
import { useScreenSize } from '@ps/web-shared-components';
import classNames from 'clsx';
import React from 'react';
import { useSelector } from 'react-redux';

import StarsButton from '@swf/components/StarsButton/StarsButton';
import WebpWithFallback from '@swf/components/WebpWithFallback/WebpWithFallback';
import { select } from '@swf/core/store';
import { useHomeGamesWidget } from '@swf/poker';

import { TXTWCL_All_Clubs } from './Banner.messages.json';
import styles from './Banner.scss';
import ArrowLeftIcon from './assets/arrow-left.svg';
import bannerMobilePNG from './assets/banner-mobile.png';
import bannerMobile from './assets/banner-mobile.webp';
import bannerPNG from './assets/banner.png';
import banner from './assets/banner.webp';

const Banner: React.FC<{ isMainPage: boolean }> = ({ isMainPage }) => {
  const { greaterThan } = useScreenSize();
  const { widgetSelect } = useHomeGamesWidget();
  const { clubNavHidden } = useSelector(widgetSelect.uiLayout);
  const isNativeMobile = useSelector(select.device.isMobileEmbedded);

  return (
    <div className={styles.bannerContainer}>
      <div className={classNames(styles.background, { [styles.mainPage]: isMainPage })}>
        <div className={styles.content}>
          <WebpWithFallback
            src={bannerMobile}
            srcFallback={bannerMobilePNG}
            containerClassName={styles.bannerMobile}
            imageSize={{ height: 1280, width: 97 }}
          />
          <WebpWithFallback
            src={banner}
            srcFallback={bannerPNG}
            containerClassName={styles.bannerImage}
            imageSize={{ height: 320, width: 80 }}
          />
          {!isNativeMobile && (
            <StarsButton
              className={classNames(styles.backIcon, {
                [styles.backHidden]: clubNavHidden
              })}
              alias="homeGamesClubs"
              icon={<ArrowLeftIcon />}
              translation={greaterThan(Size.XXSmall) ? TXTWCL_All_Clubs : undefined}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Banner;
